import { Flex, Skeleton, SkeletonText } from '@chakra-ui/react';
import './FilterAndResultsSectionSkeleton.scss';
import React from 'react';

const FilterAndResultsSectionSkeleton = () => {
  const skeletonAssetCards = Array(6)
    .fill(1)
    .map((_, i) => i + 1);

  return (
    <Flex className={'filter-and-results-section-skeleton-container'}>
      <Flex className={'filter-section-skeleton-container'}>
        <Skeleton className={'asset-filter-skeleton-button'} />
        <Skeleton className={'industry-filter-skeleton-button'} />
      </Flex>

      {skeletonAssetCards.map(key => (
        <Flex className={'custom-card-skeleton-container'} key={key}>
          <Flex className={'custom-card-text-skeleton-container'}>
            <SkeletonText
              noOfLines={1}
              skeletonHeight="3"
              className={'custom-card-skeleton-badge'}
            />
            <SkeletonText
              noOfLines={1}
              skeletonHeight="7"
              className={'custom-card-skeleton-header'}
            />
            <SkeletonText
              noOfLines={3}
              skeletonHeight="5"
              className={'custom-card-skeleton-description'}
            />
          </Flex>

          <Skeleton className={'custom-card-image-skeleton-container'} />
        </Flex>
      ))}
    </Flex>
  );
};

export default FilterAndResultsSectionSkeleton;
